'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconStopSquare, iconStopSquareTag } from '@ni/nimble-components/dist/esm/icons/stop-square';
import { wrap } from '../../utilities/react-wrapper';

export type { IconStopSquare };
export { iconStopSquareTag };
export const NimbleIconStopSquare = wrap(IconStopSquare);